import { render, staticRenderFns } from "./SelectArticlesDialog.vue?vue&type=template&id=1153aaf3"
import script from "./SelectArticlesDialog.vue?vue&type=script&lang=ts"
export * from "./SelectArticlesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports